import { Button } from "@emanprague/ppaskit";
import React from "react";
import styles from "./style.module.scss";
import bankIdLogo from "./bankidLogo.svg";

interface BankIdButtonProps {
  label: string;
  url: string;
}

// https://ux.bankid.cz/styleguide/tlacitka
const BankIdButton: React.FC<BankIdButtonProps> = ({ label, url }) => {
  return (
    <Button href={url} variant="secondary" block={true} className={styles.bankIdButton}>
      <img src={bankIdLogo} className={styles.bankIdButton__img} alt="BankID logo" />
      <span className={styles.bankIdButton__label}>{label}</span>
    </Button>
  );
};

export default BankIdButton;
